<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxSourceCell from "../../../../../../_shared/_modules/inbox-source-cell"
  import type { VerifyCustomerDraft, VerifyCustomerRow } from "../../contract"

  let props: InboxWorkflowCellProps<VerifyCustomerRow, VerifyCustomerDraft> = $props()

  const row = $derived(props.row)
</script>

<InboxSourceCell label={row.sourceLabel} subLabel={row.sourceSubLabel} disabled={row.disabled} />
